import { customerServiceCustomerDetailsEntryPoint } from '@jira/jira-spa-apps-customer-service-customer-details/entrypoint.tsx';
import { l1CustomersProjectProviderResource } from '@jira/jira-router-resources-customer-service-l1-customers-project-provider/services/index.tsx';
import { customerServiceCustomerDetailsRoute } from '@atlassian/jira-router-routes-customer-services-customers-routes/src/customerServiceCustomerDetailsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { CustomerDetailsPageQueryResource } from '@atlassian/jira-router-resources-service-desk-customer-service-customer-details/src/services/ui-customer-details-page-query-resource/index.tsx';
import { EntitlementsQueryResource } from '@atlassian/jira-router-resources-service-desk-customer-service-customer-details/src/services/entitlements-customer-query-resource/index.tsx';

const customerServiceCustomerDetailsPageEntryPoint = createPageEntryPoint({
	main: customerServiceCustomerDetailsEntryPoint,
});

export const customerServiceCustomerDetailsRouteEntry = createEntry(
	customerServiceCustomerDetailsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.customer-details',
		layout: globalLayout,

		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('berry-6285-customers-l1')
				? customerServiceCustomerDetailsPageEntryPoint
				: undefined;
		},

		resources: [
			...getNavigationResources(),
			CustomerDetailsPageQueryResource,
			EntitlementsQueryResource,
			l1CustomersProjectProviderResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceCustomerDetailsRouteEntry.tsx',
				whichExportToUse: 'customerServiceCustomerDetailsRouteEntry',
			},

			enabled: true,
		},
	}),
);
